import React from 'react';
import 'moment/locale/en-gb';
import {connect} from 'react-redux';
import {loginByPassenger} from '../../actions/authenticationActions';
import {themableImagePath} from '../../utils/imageUtils';
import TextInputWithLabel from '../../components/TextInputWithLabel';
import {getLoginPageTexts} from "../../utils/themeUtils";
import {classNames} from "../../utils/miscUtils";
import CalendarPicker from "../../components/CalendarPicker";
import {dateAddMonths, dateObjectToDMY, dateSubMonths} from "../../utils/dateTimeUtils";
import { navigate } from '../../utils/navigationUtils';

const texts = getLoginPageTexts();

class PassengerLoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            departureDate: "",
            bookingReference: "",
            leadPassengerLastName: "",
            loginInProgress: false,
            showError: false,
            isSubmitDisabled: true,
        };
    }

    handleFormChange = (field, value) => {
        if(field === "departureDate") {
            value = dateObjectToDMY(value);
        }

        const state = {...this.state};
        state[field] = value;

        state.isSubmitDisabled = state.departureDate === "" ||
            state.bookingReference === "" ||
            state.leadPassengerLastName === "";

        this.setState(state);
    }
    
    render() {
        return (
            <div className="container mx-auto">
                <h1 className="normal-case text-5xl mb-6">{texts.title}</h1>

                <LoginPageInfoText classes="hidden md:block"/>
                <form className="mb-6 md:mb-8" onSubmit={(e) => this._onLogin(e)}>
                    <div className="flex flex-wrap">
                        <LoginPageInfoText classes="block md:hidden"/>
                        <div className="w-full md:w-2/5 xl:w-1/3 mt-6 p-4 bg-grey-lightest-2 border">
                            <div className="sm:w-1/2 md:w-full">
                                <div>
                                    <label htmlFor="login-datepicker" className="input-label">
                                        {texts.dateLabel}
                                    </label>
                                    <CalendarPicker
                                        id="login-datepicker"
                                        onChange={value => this.handleFormChange("departureDate", value)}
                                        className="input-field text-black mt-1"
                                        minDate={this.props.isAgency ? dateSubMonths(new Date(), 6) : new Date()}
                                        maxDate={dateAddMonths(new Date(), 15)}
                                    />
                                </div>

                                <div className="mt-4">
                                    <TextInputWithLabel
                                        classNames="w-full"
                                        label={texts.bookingRefLabel}
                                        subLabel={texts.bookingRefSubLabel}
                                        subLabelIcon={texts.bookingRefSubLabelIcon}
                                        value={this.state.bookingReference}
                                        _onChange={value => this.handleFormChange("bookingReference", value)}
                                        placeholder={texts.bookingRefPlaceholder}
                                    />
                                </div>

                                <div className="mt-4">
                                    <TextInputWithLabel
                                        classNames="w-full"
                                        label={texts.lastNameLabel}
                                        value={this.state.leadPassengerLastName}
                                        _onChange={value => this.handleFormChange("leadPassengerLastName", value)}
                                        placeholder={texts.lastNamePlaceholder}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="w-full md:w-3/5 xl:w-2/3 order-first md:order-0 md:pl-4 mt-6">
                            <div className="bg-primary-lightest-25 shadow h-full px-4 py-2">
                            <div className="relative w-full h-full flex items-center justify-center">
                                <img
                                    className="md:absolute max-h-full max-w-sm md:max-w-full"
                                    alt={texts.imageAltText}
                                    src={themableImagePath(texts.imageFileName)}
                                />
                            </div>
                            </div>
                        </div>
                        {this.state.showError &&
                        <div className="w-full mt-4 errors">Login Failed, please check your data and try again.</div>
                        }
                        <div className="mt-6 w-full sm:w-1/2 md:w-2/5 xl:w-1/3">
                            <input type="submit"
                                disabled={this.state.loginInProgress || this.state.isSubmitDisabled}
                                className={`w-full action-button ${this.state.loginInProgress || this.state.isSubmitDisabled ? "action-button-disabled" : "action-button-enabled"}`}
                                value="Continue"/>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    async _onLogin(e) {
        e.preventDefault();
        if(this.state.loginInProgress) {
            return;
        }

        this.setState({loginInProgress: true});
        const valid = await this.props.loginByPassenger(this.state.departureDate, this.state.bookingReference, this.state.leadPassengerLastName)
        if (valid) {
            if(this.props.location.state?.forward_to) {
                navigate(this.props.location.state.forward_to);
            }
        }
        else {
            this.setState({showError: true, loginInProgress: false});
        }
    }
}

function mapStateToProps(state) {
    return {
        isAgency: state.agency.isAuthenticated,
    };
}

export default connect(mapStateToProps, {loginByPassenger})(PassengerLoginForm);


function LoginPageInfoText(props) {
    return (
        <div className={classNames("w-full text-grey-darker mt-6", props.classes)}>
            <p>{texts.infoDescription}</p>
            {texts.infoItems.length > 0 &&
            <ul className="list-square list-inside mt-4">
                {texts.infoItems.map((infoItem, index) =>
                <li key={index} className="mt-2">{infoItem}</li>
                )}
            </ul>
            }
        </div>
    );
}
